// src/config/runtimeConfig.js
const bool = (value, fallback = false) => {
  if (value === undefined || value === null) return fallback;
  if (typeof value === 'boolean') return value;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return fallback;
  return ['1', 'true', 'yes', 'on'].includes(normalized);
};

const str = (value, fallback = '') => {
  if (value === undefined || value === null) return fallback;
  const normalized = String(value).trim();
  return normalized ? normalized : fallback;
};

const DEFAULT_MOCK_API_SOURCE = 'mock';
const isDev = import.meta.env.DEV === true;
export const mockApiSource = DEFAULT_MOCK_API_SOURCE;
export const resolveMockOrderExecutionAdapter = (apiSource = mockApiSource) => {
  const normalizedApiSource = str(apiSource, DEFAULT_MOCK_API_SOURCE).toLowerCase();

  if (normalizedApiSource === 'square' || normalizedApiSource === 'sqaure') return 'square_pos';
  if (normalizedApiSource === 'toast' || normalizedApiSource === 'toast_pos') return 'website_agent';
  if (normalizedApiSource === 'doordash') return 'doordash_marketplace';
  if (normalizedApiSource === 'manual') return 'website_agent';
  if (normalizedApiSource === 'mock') return 'mock';

  return normalizedApiSource;
};

export const mockOrderExecutionAdapter = resolveMockOrderExecutionAdapter(mockApiSource);

// Default provider is env-driven so marketplace selection can be adjusted without code changes.
export const defaultProvider = str(import.meta.env.VITE_DEFAULT_PROVIDER, 'doordash').toLowerCase();
const paymentsMock = bool(import.meta.env.VITE_PAYMENTS_MOCK, true);
// Whether orders are placed against sandbox/test infrastructure (Deliverect
// sandbox, Stripe test mode, staging). This is a deployment-environment truth,
// separate from paymentsMock (which only means the payment step is faked) — a
// staging build uses real test-mode Stripe yet is still a sandbox. Set
// VITE_ORDER_SANDBOX=true on staging and =false on production. Falls back to
// paymentsMock when unset so existing environments keep their prior behavior.
const orderSandbox = bool(import.meta.env.VITE_ORDER_SANDBOX, paymentsMock);

export const runtimeConfig = {
  featureFlags: {
    // Mock order routing is now derived from restaurant/provider api_source instead of a global env flag.
    ordersMock: false,
    paymentsMock,
    orderSandbox,
    orderSmsNotifications: bool(
      import.meta.env.VITE_ORDER_SMS_NOTIFICATIONS,
      !(isDev || paymentsMock)
    ),
    // "Payment Methods" in the account menu. Off: the Profile page shows and
    // manages payments (2026-10-15). The page and route stay for when it's back.
    paymentMethodsMenuItem: bool(import.meta.env.VITE_PAYMENT_METHODS_MENU_ITEM, false),
  },
  defaultProvider,
  mockApiSource,
  mockOrderExecutionAdapter,
  resolveMockOrderExecutionAdapter,
};

export const featureFlags = runtimeConfig.featureFlags;
